export default __webpack_public_path__ + "static/media/mobile.0bb0b5c5.png";